import { IconCheckDefault } from '@mc/design-system'

interface PricingItemProps {
  children: string
}

export const PricingItem = ({ children }: PricingItemProps) => (
  <div className='d-flex align-items-start'>
    <IconCheckDefault
      className='mc-text-color--success flex-shrink-0 mc-icon--scale-3 mc-me-3'
      style={{ marginTop: '0.35em' }}
    />
    <span className='mc-text-color--medium mc-ml-3'>{children}</span>
  </div>
)
